import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/mail.vue
var o = {
	name: "DtIconMail",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--mail"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Mail",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 13 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M2.5 2.5A.5.5 0 0 0 2 3v.225l4.252 2.702a.47.47 0 0 0 .496 0h.002L11 3.224V3a.5.5 0 0 0-.5-.5h-8Zm9.5.992V3a1.5 1.5 0 0 0-1.5-1.5h-8A1.5 1.5 0 0 0 1 3v6a1.5 1.5 0 0 0 1.5 1.5h8A1.5 1.5 0 0 0 12 9V3.492Zm-1 .918L7.28 6.774a1.47 1.47 0 0 1-1.56 0l-.003-.002L2 4.41V9a.5.5 0 0 0 .5.5h8A.5.5 0 0 0 11 9V4.41Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=mail.js.map